import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from "@angular/core";
import { EnvironmentConfig } from "../../../core/models/environment-config.model";
import { LogService } from "../../../core/services/log.service";
import { VideoLightboxService } from "../../services/video-lightbox.service";

declare var environment: EnvironmentConfig;

@Component({
  selector: "common-jumbotron",
  templateUrl: "./jumbotron.component.html",
  styleUrls: ["./jumbotron.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JumbotronComponent {
  @Input() preHeader: string;
  @Input() header: string;
  @Input() subHeader: string;
  @Input() imagePath: string;
  @Input() iconClass: string;
  @Input() buttonText: string;
  @Input() videoUrl: string;
  @Input() isTopOfPage: boolean = false;
  @Input() buttonClickTrackingEvent: string;
  @Output() buttonClick = new EventEmitter();

  baseImagePath = environment.baseImagePath;

  constructor(private logService: LogService, private videoLightboxService: VideoLightboxService) {}

  click() {
    this.buttonClick.emit();
  }

  watchVideo() {
    if (this.buttonClickTrackingEvent) {
      this.logService.trackEvent(this.buttonClickTrackingEvent);
    }

    this.videoLightboxService.create(this.videoUrl);
  }
}
